import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateName, validateName2, ValidText } from "../../contexts/Utils";
import {
  AddProductApi,
  GetAllBrands,
  GetAllCategories,
  GetAllUnits,
  GetAllTags,
  AddProductImage,
  CheckProdNameCodeExist,
  GetProductById,
  AddImage,
  GetAllTypes,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
//import hello from "../../data/default_prod2.png";
import "../../styles/AddProduct.css";
import { Container, Col, Row } from "react-bootstrap";
import imageCompression from "browser-image-compression";
import Select from "react-select";
// import { storage } from "../../api/FirebaseConfig";
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

const AddProduct = () => {
  const location = useLocation();
  const { currentColor, productImageLimit, userID, userToken } =
    useStateContext();
  const [Type, setType] = useState("Select Type");
  const [Unit, setUnit] = useState("Select Unit");
  const [Category, setCategory] = useState("Select Category");
  const [Brand, setBrand] = useState("Select Brand");
  const [Tag, setTag] = useState([]);
  const [DisplayProduct, setDisplayProduct] = useState(0);
  const [ActiveProduct, setActiveProduct] = useState(0);
  // const [loading, setLoading] = useState(false);
  // const [videoBlob, setVideoBlob] = useState(null);
  const [pname, setpname] = useState("");
  const [pname2, setpname2] = useState("");
  const [pcode, setpcode] = useState("");
  //const [pexist, setpexist] = useState("");
  // const fileInputImgRef1 = useRef(null);
  // const fileInputImgRef2 = useRef(null);
  // const fileInputImgRef3 = useRef(null);
  // const fileInputImgRef4 = useRef(null);
  const fileInputRef = useRef([]);
  const [gettypes, setTypes] = useState([]);
  const [gettags, setTags] = useState([]);
  const [getunits, setUnits] = useState([]);
  const [getbrands, setbrands] = useState([]);
  const [getcategories, setCategories] = useState([]);
  const [visibleCard, setVisibleCard] = useState(1);
  const [ValError, setValError] = useState([]);
  const [loadBtn, setLoadBtn] = useState(false);
  const navigate = useNavigate();
  //const [compressedFile, setCompressedFile] = useState(null);

  // const dataURLtoFile = (dataurl, filename) => {
  //   const arr = dataurl.split(",");
  //   const mime = arr[0].match(/:(.*?);/)[1];
  //   const bstr = atob(arr[1]);
  //   let n = bstr.length;
  //   const u8arr = new Uint8Array(n);
  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n);
  //   }
  //   return new File([u8arr], filename, { type: mime });
  // };

  // const handleVideoFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file.size > 31457280) {
  //     alert("Video File max size is 30 MB!");
  //     return;
  //   }
  //   if (file) {
  //     setLoading(true);
  //     const reader = new FileReader();

  //     reader.onloadend = () => {
  //       // Convert the result to a Blob
  //       const blob = new Blob([reader.result], { type: file.type });
  //       setVideoBlob(blob);
  //       setLoading(false);
  //     };

  //     // Read the file as a binary string
  //     reader.readAsArrayBuffer(file);
  //   }
  // };

  const validName1 = (name, ii) => {
    const updatedErrors = [...ValError];
    if (name.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (validateName(name)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const validName2 = (name, ii) => {
    const updatedErrors = [...ValError];
    if (name.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (validateName2(name)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const ValidText1 = (txt, ii) => {
    const updatedErrors = [...ValError];
    if (txt.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (ValidText(txt)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const [images, setImages] = useState([]);

  const handleChangeType = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        // console.log(selectedOption);
        setType(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[9] = "";
        setValError(updatedErrors);
      } else {
        setType("Select Type");
      }
    } catch (err) {}
  };

  const handleChangeUnit = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        // console.log(selectedOption);
        setUnit(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[4] = "";
        setValError(updatedErrors);
      } else {
        setUnit("Select Unit");
      }
    } catch (err) {}
  };

  const handleChangeCategory = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setCategory(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[5] = "";
        setValError(updatedErrors);
      } else {
        setCategory("Select Category");
      }
    } catch (err) {}
  };

  const handleChangeBrand = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setBrand(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[6] = "";
        setValError(updatedErrors);
      } else {
        setBrand("Select Brand");
      }
    } catch (err) {}
  };

  const handleChangeTag = (selectedOptions) => {
    setTag(selectedOptions || []);
  };

  const handleChangeDisplay = (e) => {
    setDisplayProduct((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeName = (e) => {
    setpname(e.target.value);
  };

  const handleChangeName2 = (e) => {
    setpname2(e.target.value);
  };

  const handleChangeCode = (e) => {
    setpcode(e.target.value);
  };

  const handleChangeActive = (e) => {
    setActiveProduct((prev) => (prev === 0 ? 1 : 0));
  };

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("Back");
      navigate("/Product");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleImageChange = (e, imageID, fInput) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 4194304) {
        fInput.current[imageID].value = "";
        alert("Image File max size is 4 MB!");
        setImages((prevImages) =>
          prevImages.map((image) =>
            image.id === imageID
              ? { ...image, file: null, preview: null }
              : image,
          ),
        );
        e.target.value = null;
        return;
      }
      // if(file === undefined){
      //     const imgs = [...images];
      //     imgs[imageID].file = null;
      //     imgs[imageID].preview = null;
      //     setImages(imgs);
      //     console.log(imgs);
      //  }
      else {
        const updatedImg = images.map((image) =>
          image.id === imageID
            ? {
                ...image,
                file,
                preview: file ? URL.createObjectURL(file) : null,
              }
            : image,
        );
        //console.log(updatedImg);
        setImages(updatedImg);
        // }

        if (imageID === visibleCard) {
          const nextVisibleCard = Math.min(visibleCard + 1, images.length);
          setVisibleCard(nextVisibleCard);
        }
      }
      // else {
      //   // If user removed the image, update the visible card
      //   const nextVisibleCard = Math.min(imageID, images.length);
      //   setVisibleCard(nextVisibleCard);

      //   // If the removed card is the first one, update ProductImage and uploadedImage
      //   if (nextVisibleCard === 1) {
      //     setProductImage(images[1].file || dataURLtoFile(hello, 'hello.jpg'));
      //     setUploadedImage(images[1].file ? URL.createObjectURL(images[1].file) : hello);
      //   }
      // }

      // setProductImage(file);
      // const reader = new FileReader();
      // reader.onloadend = () => {
      //   setUploadedImage(reader.result);
      // };
      // reader.readAsDataURL(file);
    }
  };

  // const handleClickRemoveVideo = () => {
  //   setVideoBlob(null);
  //   // console.log(fileInputRef);
  //   fileInputRef.current.value = "";
  // };

  const handleClickRemoveImage = (id, fInput) => {
    fInput.current[id].value = "";
    setImages((prevImages) =>
      prevImages.map((image) =>
        image.id === id ? { ...image, file: null, preview: null } : image,
      ),
    );
  };

  const handleAddUnitClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("AddUnit");
      const { InitialCost, Details, Discount, UnitPrice } = document.forms[0];
      const formd = {
        pname: pname,
        pname2: pname2,
        pcode: pcode,
        InitialCost: InitialCost.value,
        UnitPrice: UnitPrice.value,
        Discount: Discount.value,
        Details: Details.value,
        Unit: Unit,
        Category: Category,
        Brand: Brand,
        DisplayProduct: DisplayProduct,
        ActiveProduct: ActiveProduct,
      };
      localStorage.setItem("ProductData", JSON.stringify(formd));
      navigate("/Product/AddEditUnit", {
        state: { fromPage: "AddProduct" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddBrandClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("AddBrand");
      const { InitialCost, Details, Discount, UnitPrice } = document.forms[0];
      const formd = {
        pname: pname,
        pname2: pname2,
        pcode: pcode,
        InitialCost: InitialCost.value,
        UnitPrice: UnitPrice.value,
        Discount: Discount.value,
        Details: Details.value,
        Unit: Unit,
        Category: Category,
        Brand: Brand,
        DisplayProduct: DisplayProduct,
        ActiveProduct: ActiveProduct,
      };
      localStorage.setItem("ProductData", JSON.stringify(formd));
      navigate("/Product/AddEditBrand", {
        state: { fromPage: "AddProduct" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddCategoryClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("AddCategory");
      const { InitialCost, Details, Discount, UnitPrice } = document.forms[0];
      const formd = {
        pname: pname,
        pname2: pname2,
        pcode: pcode,
        InitialCost: InitialCost.value,
        UnitPrice: UnitPrice.value,
        Discount: Discount.value,
        Details: Details.value,
        Unit: Unit,
        Category: Category,
        Brand: Brand,
        DisplayProduct: DisplayProduct,
        ActiveProduct: ActiveProduct,
      };
      localStorage.setItem("ProductData", JSON.stringify(formd));
      navigate("/Product/AddEditCategory", {
        state: { fromPage: "AddProduct" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddTagClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      const { InitialCost, Details, Discount, UnitPrice } = document.forms[0];
      const formd = {
        pname: pname,
        pname2: pname2,
        pcode: pcode,
        InitialCost: InitialCost.value,
        UnitPrice: UnitPrice.value,
        Discount: Discount.value,
        Details: Details.value,
        Unit: Unit,
        Category: Category,
        Brand: Brand,
        DisplayProduct: DisplayProduct,
        ActiveProduct: ActiveProduct,
      };
      localStorage.setItem("ProductData", JSON.stringify(formd));
      navigate("/Product/AddEditTag", {
        state: { fromPage: "AddProduct" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const insertImage = async (imgg, product_idss, i) => {
    // imgg.preventDefault();
    // const options = {
    //   maxSizeMB: 1.5, // Maximum file size in MB
    //   maxWidthOrHeight: 10000, // Maximum width or height of the image
    //   useWebWorker: true, // Use web worker for faster compression
    // };
    // const options1 = {
    //   maxSizeMB: 0.05, // Maximum file size in MB
    //   maxWidthOrHeight: 1500, // Maximum width or height of the image
    //   useWebWorker: true, // Use web worker for faster compression
    // };
    if (imgg) {
      const options = {
        maxSizeMB: 0.04, // Maximum file size in MB
        maxWidthOrHeight: 1000, // Maximum width or height of the image
        useWebWorker: true, // Use web worker for faster compression
        fileType: "image/webp", // ✅ Convert to WebP
      };
      const options1 = {
        maxSizeMB: 0.15, // Maximum file size in MB
        maxWidthOrHeight: 5000, // Maximum width or height of the image
        useWebWorker: true, // Use web worker for faster compression
        fileType: "image/webp", // ✅ Convert to WebP
      };

      try {
        const compressedFile = await imageCompression(imgg, options);
        const compressedFile1 = await imageCompression(imgg, options1);
        //setCompressedFile(compressedFile);
        //console.log("Original file:", imgg.size);
        //console.log("Compressed file:", compressedFile.size);

        var f_name = pname
          .substring(0, Math.min(50, pname.length))
          .split(" ")
          .join("_");
        f_name = f_name + "_" + i.toString() + "_";
        const response1 = await AddImage(
          f_name + "sm",
          "PRODUCT",
          compressedFile,
          userID,
          userToken,
        );
        const data1 = await response1.data;
        if (data1.imageUrl) {
          const response2 = await AddImage(
            f_name + "lg",
            "PRODUCT",
            compressedFile1,
            userID,
            userToken,
          );
          const data2 = await response2.data;
          if (data2.imageUrl) {
            const response = await AddProductImage(
              product_idss,
              i,
              null, // compressedFile,
              null, // compressedFile1,
              data2.fileKey,
              data1.fileKey,
              data2.publicUrl,
              data1.publicUrl,
              data2.imageUrl,
              data1.imageUrl,
              data2.cdnUrl,
              data1.cdnUrl,
              "",
              "",
              userID,
              userToken,
            );
            if (response.status === 200) {
              return true;
            } else {
              // alert("Product image failed to upload!");
              return false;
            }
          } else {
            // alert("Product image failed to upload!");
            return false;
          }
        } else {
          // alert("Product image failed to upload!");
          return false;
        }
      } catch (error) {
        console.error("Error compressing the image:", error);
        return false;
      }
    }
  };

  async function createProduct() {
    var resp = 0;
    try {
      const { InitialCost, Details, Discount, UnitPrice } = document.forms[0];

      setValError([]);
      const updatedErrors = [...ValError];

      if (pname === "") {
        updatedErrors[0] = "Please enter product name.";
        setValError(updatedErrors);
        return resp;
      }
      if (pname !== "") {
        if (validName1(pname, 0) === false) {
          return resp;
        }
      }
      updatedErrors[0] = "";

      if (pname2 !== "") {
        if (validName2(pname2, 10) === false) {
          return resp;
        }
      }
      updatedErrors[10] = "";

      if (pcode === "") {
        updatedErrors[1] = "Please enter product code.";
        setValError(updatedErrors);
        return resp;
      }
      if (pcode !== "") {
        if (ValidText1(pcode, 1) === false) {
          return resp;
        }
      }
      updatedErrors[1] = "";

      let exi = 0;
      await CheckProdNameCodeExist(pname, pcode, userID, userToken)
        .then((resp1) => {
          const pex = resp1.data;
          if (pex[0].name === 1) {
            exi = 1;
            updatedErrors[0] = "Product name must be unique.";
            setValError(updatedErrors);
            return resp;
          }
          updatedErrors[0] = "";
          if (pex[0].code === 1) {
            exi = 1;
            updatedErrors[1] = "Product code must be unique.";
            setValError(updatedErrors);
            return resp;
          }
          updatedErrors[1] = "";
        })
        .catch((err) => {
          console.log(err.message);
        });
      if (exi === 1) {
        return resp;
      }

      if (InitialCost.value === "") {
        updatedErrors[8] = "Please enter Initial Cost.";
        setValError(updatedErrors);
        return resp;
      }
      if (InitialCost.value < 0) {
        updatedErrors[8] = "Initial Cost must be 0 or greater.";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[8] = "";

      if (UnitPrice.value === "") {
        updatedErrors[2] = "Please enter unit price.";
        setValError(updatedErrors);
        return resp;
      }
      if (UnitPrice.value < 0) {
        updatedErrors[2] = "Price must be equal or greater than 0.";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[2] = "";

      if (Discount.value === "") {
        updatedErrors[3] = "Please enter discount.";
        setValError(updatedErrors);
        return resp;
      }
      if (Discount.value < 0) {
        updatedErrors[3] = "Discount must be 0 or greater.";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[3] = "";

      if (Details.value !== "") {
        if (ValidText1(Details.value, 7) === false) {
          return resp;
        }
      }
      updatedErrors[7] = "";

      if (Type === "select" || Type === "Select Type") {
        updatedErrors[9] = "Please select Type!";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[9] = "";

      if (Unit === "select" || Unit === "Select Unit") {
        updatedErrors[4] = "Please select unit!";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[4] = "";

      if (Brand === "select" || Brand === "Select Brand") {
        updatedErrors[5] = "Please select brand!";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[5] = "";

      if (Category === "select" || Category === "Select Category") {
        updatedErrors[6] = "Please select category!";
        setValError(updatedErrors);
        return resp;
      }
      updatedErrors[6] = "";

      const type_id = Type.value;
      const unit_id = Unit.value;
      const brand_id = Brand.value;
      const category_id = Category.value;
      var vid = null;
      // if (videoBlob) {
      //   vid = videoBlob;
      // }
      var tag_ids = [];
      Tag.forEach((element) => tag_ids.push(element.value));
      var Tgs = { tags: tag_ids };

      const response = await AddProductApi(
        pname,
        pname2,
        pcode,
        Details.value,
        Discount.value,
        UnitPrice.value,
        type_id,
        unit_id,
        brand_id,
        category_id,
        DisplayProduct,
        ActiveProduct,
        vid,
        InitialCost.value,
        Tgs,
        userID,
        userToken,
      );
      resp = await response.status;
      const prodid =
        await response.data[response.data.length - 2][0].product_id;
      if (resp === 200 && prodid) {
        var ress = true;
        var ino = 0;

        for (const element of images) {
          if (element.preview !== null) {
            var ress1 = await insertImage(element.file, prodid, ino + 1);
            ress = ress && ress1;
            ino = ino + 1;
          }
        }
        // if(videoBlob){
        //   insertVideo(videoBlob, response.data[0][0].product_id)
        // }

        const formd = {
          pname: "",
          pname2: "",
          pcode: "",
          InitialCost: "",
          UnitPrice: "",
          Discount: "",
          Details: "",
          Unit: "",
          Category: "",
          Brand: "",
          DisplayProduct: 1,
          ActiveProduct: 1,
        };
        localStorage.setItem("ProductData", JSON.stringify(formd));
        if (ino > 0) {
          if (ress) {
            alert(
              "Product added successfully!\n\nImages uploaded successfully!",
            );
          } else {
            alert("Product added successfully!\n\nImage/s may not uploaded!");
          }
        }
      } else {
        const formd = {
          pname: "",
          pname2: "",
          pcode: "",
          InitialCost: "",
          UnitPrice: "",
          Discount: "",
          Details: "",
          Unit: "",
          Category: "",
          Brand: "",
          DisplayProduct: 1,
          ActiveProduct: 1,
        };
        localStorage.setItem("ProductData", JSON.stringify(formd));
        alert("Product failed to add!");
      }
    } catch (err) {
      console.error(err);
      alert("Error! Product did not save!");
    } finally {
      return resp;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const resp = await createProduct();

    setLoadBtn(false);
    if (resp === 200) {
      navigate("/Product");
    }
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const resp = await createProduct();

    setLoadBtn(false);
    if (resp === 200) {
      navigate("/Inventory/Add");
    }
  };

  // useEffect(() => {
  //   async function fetchData() {}
  //   fetchData();
  // }, [pcode, pname]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    let isMounted = true;
    async function fetchData() {
      if (userID && userToken && productImageLimit) {
        // var u = null,
        //   c = null,
        //   b = null;
        if (isMounted) {
          var imgArr = [];
          for (let i = 1; i < productImageLimit + 1; i++) {
            imgArr.push({
              id: i,
              file: null,
              preview: null,
            });
          }
          setImages(imgArr);
          await GetAllTypes(userID, userToken)
            .then((resp) => {
              const typeOptions = resp.data.map((item) => ({
                label: item.name,
                value: item.type_id,
              }));
              setTypes(typeOptions || []);
              setType(typeOptions[0]);
            })
            .catch((err) => {
              console.log(err.message);
            });

          await GetAllUnits(userID, userToken)
            .then((resp) => {
              const unitOptions = resp.data.map((item) => ({
                label: item.names,
                value: item.unit_id,
              }));
              setUnits(unitOptions || []);
            })
            .catch((err) => {
              console.log(err.message);
            });

          await GetAllBrands(userID, userToken)
            .then((resp) => {
              const brandOptions = resp.data.map((item) => ({
                label: item.name,
                value: item.brand_id,
              }));
              setbrands(brandOptions || []);
            })
            .catch((err) => {
              console.log(err.message);
            });

          await GetAllCategories(userID, userToken)
            .then((resp) => {
              const categOptions = resp.data.map((item) => ({
                label: item.name,
                value: item.category_id,
              }));
              setCategories(categOptions || []);
            })
            .catch((err) => {
              console.log(err.message);
            });

          await GetAllTags(userID, userToken)
            .then((resp) => {
              const tagOptions = resp.data.map((item) => ({
                label: item.name,
                value: item.tag_id,
              }));
              setTags(tagOptions || []);
            })
            .catch((err) => {
              console.log(err.message);
            });

          if (!JSON.parse(localStorage.getItem("ProductData"))) {
            const formd = {
              pname: "",
              pname2: "",
              pcode: "",
              InitialCost: "",
              UnitPrice: "",
              Discount: "",
              Details: "",
              Unit: "",
              Category: "",
              Brand: "",
              DisplayProduct: "",
              ActiveProduct: "",
            };
            localStorage.setItem("ProductData", JSON.stringify(formd));
          }

          //const currentPath = location.pathname;
          const { fromPage } = location.state || {};
          //console.log(fromPage);
          // if (
          //   fromPage !== "Brand" ||
          //   fromPage !== "Category" ||
          //   fromPage !== "Unit"
          // ) {
          //   const formd = {
          //     pname: "",
          //     pcode: "",
          //     InitialCost: "",
          //     UnitPrice: "",
          //     Discount: "",
          //     Details: "",
          //     Unit: "",
          //     Category: "",
          //     Brand: "",
          //     DisplayProduct: "",
          //     ActiveProduct: "",
          //   };
          //   localStorage.setItem("ProductData", JSON.stringify(formd));
          // }
          if (
            fromPage === "Brand" ||
            fromPage === "Category" ||
            fromPage === "Unit"
          ) {
            const formd = JSON.parse(localStorage.getItem("ProductData"));
            setpname(formd["pname"]);
            setpname2(formd["pname2"]);
            setpcode(formd["pcode"]);
            setActiveProduct(parseInt(formd["ActiveProduct"]));
            setDisplayProduct(parseInt(formd["DisplayProduct"]));
            setUnit(formd["Unit"]);
            setBrand(formd["Brand"]);
            setCategory(formd["Category"]);
            document.forms[0]["InitialCost"].value = formd["InitialCost"];
            document.forms[0]["UnitPrice"].value = formd["UnitPrice"];
            document.forms[0]["Discount"].value = formd["Discount"];
            document.forms[0]["Details"].value = formd["Details"];
            //console.log(formd);
          } else if (localStorage.getItem("copyProduct")) {
            const cP = localStorage.getItem("copyProduct");
            if (cP && cP !== "null") {
              const resp1 = GetProductById(cP, userID, userToken);
              resp1
                .then(function (result) {
                  setpname(result.data[0].name);
                  setpcode(result.data[0].code);
                  setActiveProduct(result.data[0].active_product);
                  setDisplayProduct(result.data[0].display_product);
                  setUnit({
                    value: result.data[0].unit_id,
                    label: result.data[0].units,
                  });
                  setBrand({
                    value: result.data[0].brand_id,
                    label: result.data[0].brand,
                  });
                  setCategory({
                    value: result.data[0].category_id,
                    label: result.data[0].category,
                  });
                  const tagOptions = result.data[0].tags.map((item) => ({
                    label: item.tag,
                    value: item.tag_id,
                  }));
                  setTag(tagOptions);
                  document.forms[0]["UnitPrice"].value =
                    result.data[0].unit_price;
                  document.forms[0]["Discount"].value = result.data[0].discount;
                  document.forms[0]["Details"].value = result.data[0].details;
                })
                .catch((err) => {
                  console.log(err.message);
                });
            }
            localStorage.setItem("copyProduct", null);
          }
        }
      }
    }
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [location.state, userID, userToken, productImageLimit]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      {/* <div className="user-body"> */}
      <Header title="ADD PRODUCT" />
      {/* <div className="offset-lg-3 col-md-6"> */}
      {/* <form className="container-product"> */}
      <form>
        {/* <div className="article-container-product">
              <div className="flex justify-left"> */}
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          {/* <div className="article-product"> */}
          <Row xs={1} sm={1} style={{ padding: "0" }}>
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Name:</label>
                  <input
                    required
                    type="text"
                    name="ProductNames"
                    placeholder="Name"
                    value={pname}
                    onChange={handleChangeName}
                    className="input"
                    autoFocus
                    maxLength={99}
                    onBlur={(e) => validName1(e.target.value, 0)}
                  />
                  <span className="label-imp">*</span>
                  {ValError[0] && <p className="label-error">{ValError[0]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Other Name:</label>
                  <input
                    dir="rtl"
                    type="text"
                    name="ProductNames2"
                    placeholder="اردو نام"
                    value={pname2}
                    onChange={handleChangeName2}
                    className="input"
                    maxLength={199}
                    onBlur={(e) => validName2(e.target.value, 10)}
                  />
                  {/* <span className="label-imp">*</span> */}
                  {ValError[10] && (
                    <p className="label-error">{ValError[10]}</p>
                  )}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Code: </label>
                  <input
                    required
                    type="text"
                    value={pcode}
                    onChange={handleChangeCode}
                    name="ProductCode"
                    placeholder="Code"
                    className="input"
                    maxLength={14}
                    onBlur={(e) => ValidText1(e.target.value, 1)}
                  />
                  <span className="label-imp">*</span>
                  {ValError[1] && <p className="label-error">{ValError[1]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Initial Cost: </label>
                  <input
                    type="number"
                    step="1.00"
                    min="0"
                    defaultValue={0}
                    name="InitialCost"
                    placeholder="Initial Cost"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[8] && <p className="label-error">{ValError[8]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Unit Price: </label>
                  <input
                    type="number"
                    step="1.00"
                    min="0"
                    defaultValue={0}
                    name="UnitPrice"
                    placeholder="Price"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Discount:</label>
                  <input
                    type="number"
                    step="1.00"
                    min="0"
                    name="Discount"
                    defaultValue={0}
                    placeholder="Discount"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[3] && <p className="label-error">{ValError[3]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Description:</label>
                  <textarea
                    placeholder="Description"
                    name="Details"
                    id="noteTextarea"
                    // value={Details}
                    //onChange={handleChangeNote}
                    rows="4"
                    maxLength={499}
                    className="textarea"
                    onBlur={(e) => ValidText1(e.target.value, 7)}
                  />
                  {ValError[7] && <p className="label-error">{ValError[7]}</p>}
                </div>
              </div>

              <br />
              <br />
              {/* </div> */}
            </Col>
            {/* <div className="article-product"> */}
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="TypeSelect">
                    Type:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="TypeSelect"
                      className="myreact-select container-select"
                      value={Type}
                      onChange={handleChangeType}
                      options={gettypes}
                    />
                    <span className="label-imp-select">*</span>
                  </div>
                  {ValError[9] && <p className="label-error">{ValError[9]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="UnitSelect">
                    Unit:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="UnitSelect"
                      className="myreact-select container-select"
                      value={Unit}
                      onChange={handleChangeUnit}
                      options={getunits}
                    >
                      {/* <option defaultValue="select">Select Unit</option>
                    {getunits.map((item) => (
                      <option key={item.unit_id}>{item.names}</option>
                    ))} */}
                    </Select>
                    <span className="label-imp-select-prd">*</span>
                    <button className="plus-btn" onClick={handleAddUnitClick}>
                      +
                    </button>
                  </div>
                  {ValError[4] && <p className="label-error">{ValError[4]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="BrandSelect">
                    Brand:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="BrandSelect"
                      className="myreact-select container-select"
                      value={Brand}
                      onChange={handleChangeBrand}
                      options={getbrands}
                    ></Select>
                    <span className="label-imp-select-prd">*</span>
                    <button className="plus-btn" onClick={handleAddBrandClick}>
                      +
                    </button>
                  </div>
                  {ValError[5] && <p className="label-error">{ValError[5]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="CategorySelect">
                    Category:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="CategorySelect"
                      className="myreact-select container-select"
                      value={Category}
                      onChange={handleChangeCategory}
                      options={getcategories}
                    ></Select>
                    <span className="label-imp-select-prd">*</span>
                    <button
                      className="plus-btn"
                      onClick={handleAddCategoryClick}
                    >
                      +
                    </button>
                  </div>
                  {ValError[6] && <p className="label-error">{ValError[6]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="TagSelect">
                    Tag:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="TagSelect"
                      className="myreact-select container-select"
                      value={Tag}
                      onChange={handleChangeTag}
                      options={gettags}
                      isMulti
                    ></Select>
                    <span className="label-imp-select-prd"></span>
                    <button className="plus-btn" onClick={handleAddTagClick}>
                      +
                    </button>
                  </div>
                  {ValError[11] && (
                    <p className="label-error">{ValError[11]}</p>
                  )}
                </div>
              </div>
              <br />
              <br />
              <label className="mt-4 label-checkbox">
                <input
                  type="checkbox"
                  value="ActiveProduct"
                  checked={ActiveProduct === 1}
                  onChange={handleChangeActive}
                />
                {` `}Active Product
              </label>
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="DisplayProduct"
                  checked={DisplayProduct === 1}
                  onChange={handleChangeDisplay}
                />
                {` `}Display Product
              </label>
              <br />

              {/* <div className="mt-3 col-lg-12">
                <div className="form-group">
                  <label className="label">Video:</label>
                  <div>
                    {loading && <p>Loading...</p>}
                    {videoBlob && (
                      <div className="container-video-div">
                        <video
                          controls
                          src={URL.createObjectURL(videoBlob)}
                          type="video/mp4"
                          className="container-video"
                          alt={`Product Video`}
                        />
                        <button
                          className="crs-btn"
                          type="button"
                          onClick={handleClickRemoveVideo}
                        >
                          ❌
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="mt-1 product-image-input">
                    <input
                      title=" "
                      ref={fileInputRef}
                      type="file"
                      accept="video/*"
                      onChange={handleVideoFileChange}
                    />
                  </div>
                </div>
              </div>
              <br /> */}
              <br />
            </Col>
            {/* <div className="article-container-product">
            <div className="article-product1">
              <div
                className="card-product"
                style={{
                  display: "flex",
                  marginTop: "30px",
                }}
              > */}
            {productImageLimit > 0 && (
              <Col md={4} className="container-col">
                <div className="mt-0 col-lg-12">
                  {/* <div className="form-group"> */}
                  {images.map((image, index) => (
                    // <div
                    //   key={image.id}
                    //   className="card-product"
                    //   style={{
                    //     width: "100%",
                    //     height: "152px",
                    //     display: visibleCard >= image.id ? "flex" : "none",
                    //     flexDirection: "row",
                    //   }}
                    // >
                    <div
                      key={index}
                      // style={{
                      //   display: visibleCard >= image.id ? "flex" : "none",
                      // }}
                      // className="card-product"
                      // style={{
                      //   width: "100%",
                      //   height: "152px",
                      //   display: visibleCard >= image.id ? "flex" : "none",
                      //   flexDirection: "row",
                      // }}
                    >
                      {/* <div className="article-product-card">
                        <div> */}
                      <div className="container-video-div">
                        {/* <div className="wrapper-product"> */}
                        {image.preview && (
                          <img
                            src={image.preview}
                            // className="box-product"
                            className="container-image"
                            alt={`Product ${image.id}`}
                            // style={{
                            //   maxWidth: "100%",
                            //   maxHeight: "100%",
                            //   objectFit: "contain",
                            // }}
                          />
                        )}
                        <div className="crs-btn-image">
                          {image.preview && (
                            <button
                              type="button"
                              onClick={(e) =>
                                handleClickRemoveImage(image.id, fileInputRef)
                              }
                            >
                              ❌
                            </button>
                          )}
                          {/* </div> 71,96,39 */}
                          <div className="product-image-label">
                            <label
                              className="container-label"
                              htmlFor={`imageInput${image.id}`}
                            >{`Image ${image.id}:`}</label>
                          </div>

                          <div className="product-image-input">
                            <input
                              ref={(ref) => {
                                fileInputRef.current[index] = ref;
                              }}
                              className="flex justify-left"
                              type="file"
                              id={`imageInput${image.id}`}
                              accept="image/*"
                              onChange={(e) =>
                                handleImageChange(e, image.id, fileInputRef)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* </div>
                      </div> */}
                      {/* <div className="article-product-card"> */}
                      {/* <button
                          type="button"
                          onClick={(e) => handleClickRemoveImage(image.id)}
                        >
                          ❌
                        </button> */}
                      {/* <div> */}
                      {/* <div className="product-image-label">
                            <label
                              className="container-label"
                              htmlFor={`imageInput${image.id}`}
                            >{`Image ${image.id}:`}</label>
                          </div> */}

                      {/* </div> */}
                      {/* </div> */}
                    </div>
                  ))}
                  {/* </div> */}
                </div>
                <br />
                <br />
              </Col>
            )}
          </Row>
          {/* </div>
            </div>
          </div> */}
        </Container>
        {/* </div>
            </div> */}
      </form>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="article-container-product">
        <div style={{ paddingLeft: "800px" }}> */}
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Create & Go to Add Inventory"
          borderRadius="10px"
          onClick={handleSubmit1}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Create Only"
          borderRadius="10px"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
      {/* </div>
      </div> */}
    </div>
  );
};

export default AddProduct;

/* <div>
                <div
                // className="card-product"
                // style={{
                //   display: "flex",
                //   marginTop: "30px",
                // }}
                >
                  <div>
                    <div
                      className="card-product01"
                      style={{
                        width: "100%",
                        height: "182px",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <div className="article-product-card">
                        <div>
                          {loading && <p>Loading...</p>}
                          {videoBlob && (
                            <div className="wrapper-product">
                              <video
                                title=""
                                controls
                                src={URL.createObjectURL(videoBlob)}
                                type="video/mp4"
                                className="box-product"
                                alt={`Product Video`}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="article-product-card">
                        <div>
                          <div className="product-image-label">
                            <label
                              className="container-label"
                              htmlFor={`videoInput`}
                            >{`Video:`}</label>
                          </div>
                          <div className="product-image-input">
                            <input
                              ref={fileInputRef}
                              className="flex justify-left"
                              type="file"
                              accept="video/*"
                              onChange={handleVideoFileChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="article-product-btn">
                        <button
                          style={{}}
                          type="button"
                          onClick={handleClickRemoveVideo}
                        >
                          ❌
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */
